export const hasPermission = (key: string): boolean => {
  try {
    const raw = localStorage.getItem("permissions");
    if (!raw) return false;
    const permissions: string[] = JSON.parse(raw);
    return permissions.includes(key);
  } catch (err) {
    return false;
  }
};
